import { useState } from 'react'

import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { GET_AD_UNIT_PATHS } from './api/query'
import { AdUnitPathDTO, Data, Variables } from './api/types'
import { AdUnitPath, Props, UseGet } from './types'

export const useGetAdUnitPaths = ({ domainId }: Props): UseGet => {
  const { workspaceId } = useWorkspaceParam()

  const [adUnitPaths, setAdUnitPaths] = useState<AdUnitPath[]>([])

  const { isLoading: loading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data) => {
      const {
        adUnits: { nodes: adUnitPathNodes },
      } = data

      if (adUnitPathNodes) {
        setAdUnitPaths(
          adUnitPathNodes.map(
            (node: AdUnitPathDTO): AdUnitPath => ({
              id: node.id,
              path: node.path,
            }),
          ),
        )
      }
    },
    query: GET_AD_UNIT_PATHS(),
    variables: {
      domainId,
      workspaceId,
    },
  })

  return { adUnitPaths, loading }
}
